
import LotterySignEditComponent from "../../../components/lottery_signs/Edit.vue";

export default {
  components: {
    LotterySignEditComponent
  }
};
